<template>
  <el-form :model="formData" ref="form" :rules="formRules">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('vpn.reason')">
          <el-select v-model="formData.reason" filterable 
              :placeholder="$t('ap.le-ph')" style="width:100%">
                <el-option
                  v-for="item in vpnReason"
                  :key="item.id"
                  :label="$i18n.locale === 'zh' ? item.c_name : item.e_name"
                  :value="item.id">
                </el-option>
              </el-select>
          </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('vpn.start-date')">
          <el-date-picker
            v-model="formData.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            ref="dateRange"
            style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-col>
      
      <el-col :span="24">
        <el-form-item :label="$t('vpn.comment')" prop="comment">
          <el-input
            type="textarea"
            :rows="4"
            :autosize="{ minRows: 2, maxRows: 6}"
            :placeholder="$t('service.comment-ph')"
            v-model="formData.comment"
            style="width:100%"
            >
          </el-input>
        </el-form-item>
      </el-col>
      
    </el-row>
  </el-form>
</template>
<style scoped>
</style>
<script>
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'VPNForm',
  data: function() {
  return {
    formData: {
      'id': null,
      'uid': null,
      'userId': null,
      'reason': null,
      'comment': null,
      'startDate': null,
      'dateRange': [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      'endDate': null,
      'status': 0
    },
    formRules: {
      'reason': [{required: true, message: this.$t('vpn.validate.reason'), trigger: 'blur'}]
    }
  }
  },
  computed: {
    
  },
  watch: {
  },
  methods: {
    createRequest: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(this.formData)
          let loading = Loading.service({ fullscreen: true }),
              that = this
          this.formData.userId = localStorage.getItem('token')
          this.formData.uid = localStorage.getItem('token')

          this.formData.startDate = this.formData.dateRange[0],
          this.formData.endDate = this.formData.dateRange[1]
          this.$http.post(this.API3_PREFIX + 'vpn', this.formData).then(function (response) {
            that.$nextTick(() => {
              loading.close()
            })
            that.$message({
              message: that.$t('vpn.success'),
              type: 'success'
            })
            that.$emit('value-save', that.formData)
          }).catch(function (error) {
            console.log(error)
            that.$nextTick(() => {
              loading.close();
            })
            let msg = that.$t('vpn.failed')
            if(error.response) {
              that.$message({
                message: msg,
                type: 'error'
              })
            }
          })
        } else {
          // do stuff if not valid.
          this.$message({
            message: this.$t('vpn.invalid'),
            type: 'error'
          })
          return false
        }
      })
    }
  },
  created: function() {
    
  }
}
</script>